import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split'
})
export class SplitPipe implements PipeTransform {

  /*transform(value: any, args?: any): any {
    return null;
  }*/

  transform(input: string, sep: string, inx: number): string {
    //return input.split(sep)[inx];

    /*var values: any;
    var words: any;

    values = input.split(sep)[inx]; // obtem a primeira linha do campo descricao do incidente
    words = values.split(" ", 5); // obtem as 5 primeiras palavras da primeira linha da descricao
    if (words.length >= 5) {
        return words.join(" ") + " ... ";
    }
    return words.join(" ");
    */

    //return input.split(sep,inx).join(" ");

    var words: any;
    
    words = input.split(sep,inx);
    if (words.length >= inx) {
        return words.join(" ") + " ... ";
    }

    return words.join(" ");

  }

}



// WEBPACK FOOTER //
// ./src/app/split.pipe.ts